import { UpgradeModel } from "types";

import bishopCoreFourImage from "assets/upgrade-bishop-core-four.svg";
import bishopCoreOneImage from "assets/upgrade-bishop-core-one.svg";
import bishopCoreThreeImage from "assets/upgrade-bishop-core-three.svg";
import bishopCoreTwoImage from "assets/upgrade-bishop-core-two.svg";
import bishopLaserFourImage from "assets/upgrade-bishop-laser-four.svg";
import bishopLaserOneImage from "assets/upgrade-bishop-laser-one.svg";
import bishopLaserThreeImage from "assets/upgrade-bishop-laser-three.svg";
import bishopLaserTwoImage from "assets/upgrade-bishop-laser-two.svg";
import bishopScopeFourImage from "assets/upgrade-bishop-scope-four.svg";
import bishopScopeOneImage from "assets/upgrade-bishop-scope-one.svg";
import bishopScopeThreeImage from "assets/upgrade-bishop-scope-three.svg";
import bishopScopeTwoImage from "assets/upgrade-bishop-scope-two.svg";
import bishopShieldFourImage from "assets/upgrade-bishop-shield-four.svg";
import bishopShieldOneImage from "assets/upgrade-bishop-shield-one.svg";
import bishopShieldThreeImage from "assets/upgrade-bishop-shield-three.svg";
import bishopShieldTwoImage from "assets/upgrade-bishop-shield-two.svg";
import bishopThrusterFourImage from "assets/upgrade-bishop-thruster-four.svg";
import bishopThrusterOneImage from "assets/upgrade-bishop-thruster-one.svg";
import bishopThrusterThreeImage from "assets/upgrade-bishop-thruster-three.svg";
import bishopThrusterTwoImage from "assets/upgrade-bishop-thruster-two.svg";

import {
  attackAnimation,
  reactorCoreAnimation,
  shieldsAnimation,
  targetingSystemAnimation,
  thrusterAnimation,
} from "components/styles/animations";
import {
  DEFAULT_REACTOR_SPEED,
  DEFAULT_SHIELDS_SPEED,
  DEFAULT_TARGETING_SPEED,
  DEFAULT_THRUSTERS_SPEED,
  DEFAULT_WEAPONS_SPEED,
} from "../constants";

const BISHOP_SHIPWORKS_UPGRADES: Record<string, UpgradeModel> = {
  bishop_laser_one: {
    slug: "bishop_laser_one",
    name: "Bishop Laser I",
    description: "A standard low performance laser made in Bishop City.",
    image: bishopLaserOneImage,
    animation: attackAnimation,
    animationSpeed: DEFAULT_WEAPONS_SPEED,
    part: "weapons",
    requirements: {
      firepower: 5,
    },
    grade: "basic",
    derivedStatsModifiers: {
      maxAttackDamage: 0.5,
      maxWeakenParts: 0.5,
    },
  },
  bishop_laser_two: {
    slug: "bishop_laser_two",
    name: "Bishop Laser II",
    description: "A standard medium performance laser made in Bishop City.",
    image: bishopLaserTwoImage,
    animation: attackAnimation,
    animationSpeed: DEFAULT_WEAPONS_SPEED,
    part: "weapons",
    requirements: {
      firepower: 10,
    },
    grade: "basic",
    derivedStatsModifiers: {
      maxAttackDamage: 0.5,
      maxWeakenParts: 0.5,
    },
  },
  bishop_laser_three: {
    slug: "bishop_laser_three",
    name: "Bishop Laser III",
    description: "A standard high performance laser made in Bishop City.",
    image: bishopLaserThreeImage,
    animation: attackAnimation,
    animationSpeed: DEFAULT_WEAPONS_SPEED,
    part: "weapons",
    requirements: {
      firepower: 15,
    },
    grade: "basic",
    derivedStatsModifiers: {
      maxAttackDamage: 0.5,
      maxWeakenParts: 0.5,
    },
  },
  bishop_laser_four: {
    slug: "bishop_laser_four",
    name: "Bishop Laser IV",
    description: "A standard very high performance laser made in Bishop City.",
    image: bishopLaserFourImage,
    animation: attackAnimation,
    animationSpeed: DEFAULT_WEAPONS_SPEED,
    part: "weapons",
    requirements: {
      firepower: 20,
    },
    grade: "basic",
    derivedStatsModifiers: {
      maxAttackDamage: 0.5,
      maxWeakenParts: 0.5,
    },
  },
  bishop_shield_one: {
    slug: "bishop_shield_one",
    name: "Bishop Shield I",
    description: "A standard low performance shield made in Bishop City.",
    image: bishopShieldOneImage,
    animation: shieldsAnimation,
    animationSpeed: DEFAULT_SHIELDS_SPEED,
    part: "shields",
    requirements: {
      resilience: 5,
    },
    grade: "basic",
    derivedStatsModifiers: {
      maxHealth: 0.4,
      damageReduction: 0.3,
      weakenPartsReduction: 0.3,
    },
  },
  bishop_shield_two: {
    slug: "bishop_shield_two",
    name: "Bishop Shield II",
    description: "A standard medium performance shield made in Bishop City.",
    image: bishopShieldTwoImage,
    animation: shieldsAnimation,
    animationSpeed: DEFAULT_SHIELDS_SPEED,
    part: "shields",
    requirements: {
      resilience: 10,
    },
    grade: "basic",
    derivedStatsModifiers: {
      maxHealth: 0.4,
      damageReduction: 0.3,
      weakenPartsReduction: 0.3,
    },
  },
  bishop_shield_three: {
    slug: "bishop_shield_three",
    name: "Bishop Shield III",
    description: "A standard high performance shield made in Bishop City.",
    image: bishopShieldThreeImage,
    animation: shieldsAnimation,
    animationSpeed: DEFAULT_SHIELDS_SPEED,
    part: "shields",
    requirements: {
      resilience: 15,
    },
    grade: "basic",
    derivedStatsModifiers: {
      maxHealth: 0.4,
      damageReduction: 0.3,
      weakenPartsReduction: 0.3,
    },
  },
  bishop_shield_four: {
    slug: "bishop_shield_four",
    name: "Bishop Shield IV",
    description: "A standard very high performance shield made in Bishop City.",
    image: bishopShieldFourImage,
    animation: shieldsAnimation,
    animationSpeed: DEFAULT_SHIELDS_SPEED,
    part: "shields",
    requirements: {
      resilience: 20,
    },
    grade: "basic",
    derivedStatsModifiers: {
      maxHealth: 0.4,
      damageReduction: 0.3,
      weakenPartsReduction: 0.3,
    },
  },
  bishop_thruster_one: {
    slug: "bishop_thruster_one",
    name: "Bishop Thruster I",
    description: "A standard low performance thruster made in Bishop City.",
    image: bishopThrusterOneImage,
    animation: thrusterAnimation,
    animationSpeed: DEFAULT_THRUSTERS_SPEED,
    part: "thrusters",
    requirements: {
      speed: 5,
    },
    grade: "basic",
    derivedStatsModifiers: {
      attackSpeed: 0.4,
      attackEvasion: 0.3,
      movementSpeed: 0.3,
    },
  },
  bishop_thruster_two: {
    slug: "bishop_thruster_two",
    name: "Bishop Thruster II",
    description: "A standard medium performance thruster made in Bishop City.",
    image: bishopThrusterTwoImage,
    animation: thrusterAnimation,
    animationSpeed: DEFAULT_THRUSTERS_SPEED,
    part: "thrusters",
    requirements: {
      speed: 10,
    },
    grade: "basic",
    derivedStatsModifiers: {
      attackSpeed: 0.4,
      attackEvasion: 0.3,
      movementSpeed: 0.3,
    },
  },
  bishop_thruster_three: {
    slug: "bishop_thruster_three",
    name: "Bishop Thruster III",
    description: "A standard high performance thruster made in Bishop City.",
    image: bishopThrusterThreeImage,
    animation: thrusterAnimation,
    animationSpeed: DEFAULT_THRUSTERS_SPEED,
    part: "thrusters",
    requirements: {
      speed: 15,
    },
    grade: "basic",
    derivedStatsModifiers: {
      attackSpeed: 0.4,
      attackEvasion: 0.3,
      movementSpeed: 0.3,
    },
  },
  bishop_thruster_four: {
    slug: "bishop_thruster_four",
    name: "Bishop Thruster IV",
    description:
      "A standard very high performance thruster made in Bishop City.",
    image: bishopThrusterFourImage,
    animation: thrusterAnimation,
    animationSpeed: DEFAULT_THRUSTERS_SPEED,
    part: "thrusters",
    requirements: {
      speed: 20,
    },
    grade: "basic",
    derivedStatsModifiers: {
      attackSpeed: 0.4,
      attackEvasion: 0.3,
      movementSpeed: 0.3,
    },
  },
  bishop_scope_one: {
    slug: "bishop_scope_one",
    name: "Bishop Scope I",
    description:
      "A standard low performance targeting system made in Bishop City.",
    image: bishopScopeOneImage,
    animation: targetingSystemAnimation,
    animationSpeed: DEFAULT_TARGETING_SPEED,
    part: "targetingSystem",
    requirements: {
      precision: 5,
    },
    grade: "basic",
    derivedStatsModifiers: {
      attackAccuracy: 0.4,
      minAttackDamage: 0.3,
      minWeakenParts: 0.3,
    },
  },
  bishop_scope_two: {
    slug: "bishop_scope_two",
    name: "Bishop Scope II",
    description:
      "A standard medium performance targeting system made in Bishop City.",
    image: bishopScopeTwoImage,
    animation: targetingSystemAnimation,
    animationSpeed: DEFAULT_TARGETING_SPEED,
    part: "targetingSystem",
    requirements: {
      precision: 10,
    },
    grade: "basic",
    derivedStatsModifiers: {
      attackAccuracy: 0.4,
      minAttackDamage: 0.3,
      minWeakenParts: 0.3,
    },
  },
  bishop_scope_three: {
    slug: "bishop_scope_three",
    name: "Bishop Scope III",
    description:
      "A standard high performance targeting system made in Bishop City.",
    image: bishopScopeThreeImage,
    animation: targetingSystemAnimation,
    animationSpeed: DEFAULT_TARGETING_SPEED,
    part: "targetingSystem",
    requirements: {
      precision: 15,
    },
    grade: "basic",
    derivedStatsModifiers: {
      attackAccuracy: 0.4,
      minAttackDamage: 0.3,
      minWeakenParts: 0.3,
    },
  },
  bishop_scope_four: {
    slug: "bishop_scope_four",
    name: "Bishop Scope IV",
    description:
      "A standard very high performance targeting system made in Bishop City.",
    image: bishopScopeFourImage,
    animation: targetingSystemAnimation,
    animationSpeed: DEFAULT_TARGETING_SPEED,
    part: "targetingSystem",
    requirements: {
      precision: 20,
    },
    grade: "basic",
    derivedStatsModifiers: {
      attackAccuracy: 0.4,
      minAttackDamage: 0.3,
      minWeakenParts: 0.3,
    },
  },
  bishop_core_one: {
    slug: "bishop_core_one",
    name: "Bishop Core I",
    description: "A standard low performance reactor core made in Bishop City.",
    image: bishopCoreOneImage,
    animation: reactorCoreAnimation,
    animationSpeed: DEFAULT_REACTOR_SPEED,
    part: "reactorCore",
    requirements: {
      energy: 5,
    },
    grade: "basic",
    derivedStatsModifiers: {
      fasterRecharge: 0.5,
      energyMultiplier: 0.5,
    },
  },
  bishop_core_two: {
    slug: "bishop_core_two",
    name: "Bishop Core II",
    description:
      "A standard medium performance reactor core made in Bishop City.",
    image: bishopCoreTwoImage,
    animation: reactorCoreAnimation,
    animationSpeed: DEFAULT_REACTOR_SPEED,
    part: "reactorCore",
    requirements: {
      energy: 10,
    },
    grade: "basic",
    derivedStatsModifiers: {
      fasterRecharge: 0.5,
      energyMultiplier: 0.5,
    },
  },
  bishop_core_three: {
    slug: "bishop_core_three",
    name: "Bishop Core III",
    description:
      "A standard high performance reactor core made in Bishop City.",
    image: bishopCoreThreeImage,
    animation: reactorCoreAnimation,
    animationSpeed: DEFAULT_REACTOR_SPEED,
    part: "reactorCore",
    requirements: {
      energy: 15,
    },
    grade: "basic",
    derivedStatsModifiers: {
      fasterRecharge: 0.5,
      energyMultiplier: 0.5,
    },
  },
  bishop_core_four: {
    slug: "bishop_core_four",
    name: "Bishop Core IV",
    description:
      "A standard very high performance reactor core made in Bishop City.",
    image: bishopCoreFourImage,
    animation: reactorCoreAnimation,
    animationSpeed: DEFAULT_REACTOR_SPEED,
    part: "reactorCore",
    requirements: {
      energy: 20,
    },
    grade: "basic",
    derivedStatsModifiers: {
      fasterRecharge: 0.5,
      energyMultiplier: 0.5,
    },
  },
};

export default BISHOP_SHIPWORKS_UPGRADES;
